import { registerAiImageGenerateDetailed } from "./blockly-aiimage-mutator.ts";
import { registerHiddenFieldsExtension } from "./hidden-fields-extension.ts";
import { registerListJoinMutator } from "./list-join-mutator.ts";
import {
  registerAnswerOptionsNew,
  registerButtonOutputNew,
  registerCardButtonsNew,
  registerDocSearchNewV2,
  registerOverlayClose,
  registerOverlayPromptNew,
  registerOverlayTextBtnNew,
  registerSkillForNextRunNew,
  registerTextJoinPlusMinus,
  registerToastrPreconfNew,
} from "./text-join-plus-minus.ts";

export * from "./blockly-aiimage-mutator.ts";
export * from "./hidden-fields-extension.ts";
export * from "./list-join-mutator.ts";
export * from "./text-join-plus-minus.ts";

export function registerBlocklyMutators(): void {
  registerHiddenFieldsExtension();
  registerTextJoinPlusMinus();
  registerCardButtonsNew();
  registerSkillForNextRunNew();
  registerButtonOutputNew();
  registerAnswerOptionsNew();
  registerOverlayTextBtnNew();
  registerOverlayPromptNew();
  registerOverlayClose();
  registerToastrPreconfNew();
  registerDocSearchNewV2();
  registerAiImageGenerateDetailed();
  registerListJoinMutator();
}
